import "./App.css";
import { useEffect, useMemo, useState } from "react";
import "./styles/style.css";
import "./styles/background.css";

import Main from "./components/Main";
import { loadStripe } from "@stripe/stripe-js";
import { STATE } from "./classes/Enum";

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import Trademark from "./components/Trademark";
import AddToHomeScreen from "./components/AddToHomeScreen";

import { CartContext, StateContext } from "./components/Context";
import { AuthProvider, useAuth } from "./components/AuthProvider";
import { SearchProvider } from "./components/Context";

const stripePromise = loadStripe(process.env.REACT_APP_API_STRIPE_PUBLIC_KEY);

// --------------------
// Inner app that can use useAuth()
// --------------------
function AppInner() {
  const { user, authReady } = useAuth();

  // Restore state/cart from localStorage (OK: not auth)
  const [state, setState] = useState(() => {
    const saved = localStorage.getItem("appState");
    if (saved === "RECENTLY VIEWED") {
      return STATE.OVERVIEW;
    }
    return saved ? saved : STATE.OVERVIEW;
  });

  const [cart, setCart] = useState(() => {
    try {
      const raw = localStorage.getItem("cart");
      return raw ? JSON.parse(raw) : [];
    } catch {
      return [];
    }
  });

  const [selectedItem, setSelectedItem] = useState(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1200);

  // If you still want a boot flag for UI effects, tie it to authReady
  // (so you don't show header/footer until session check completes)
  const isBooting = !authReady;

  // Persist cart (fine)
  useEffect(() => {
    localStorage.setItem("cart", JSON.stringify(cart));
  }, [cart]);

  // Persist app state (FIXED: save current state, not always OVERVIEW)
  useEffect(() => {
    localStorage.setItem("appState", String(state ?? STATE.OVERVIEW));
    setSelectedItem(null);
  }, [state]);

  useEffect(() => {
    const onResize = () => {
        setIsMobile(window.innerWidth < 1000);
    };

    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const mainElement = 
      <Main
        stripePromise={stripePromise}
        setSelectedItem={setSelectedItem}
        selectedItem={selectedItem}
        isBooting={isBooting}
        setIsBooting={() => {}}
        isMobile={isMobile}
      />;

//   document.addEventListener('contextmenu', function(event) {
//     event.preventDefault();
// });


  return (
    <StateContext.Provider value={{ state, setState }}>
      <CartContext.Provider value={{ cart, setCart }}>
        <SearchProvider>
          <Router>
            <div className="app">
              <Routes>
                <Route path="/" element={mainElement} />
                <Route path="/user/data/verify" element={mainElement} />
                <Route path="/:section" element={mainElement} />
                <Route path="/card/:cardId" element={mainElement} />
                <Route path="/products/id/:id" element={mainElement} />
                <Route path="/sets/:setId" element={mainElement} />
                <Route
                  path="/reset-password/:uid/:token"
                  element={<ResetPasswordPage />}
                />
              </Routes>

              <Trademark isMobile={isMobile}/>
              <AddToHomeScreen />
            </div>
          </Router>
        </SearchProvider>
      </CartContext.Provider>
    </StateContext.Provider>
  );
}

// --------------------
// Wrap app in AuthProvider here (so AppInner can use useAuth())
// --------------------
export default function App() {
  return (
    <AuthProvider>

    <div className="floating-glow-bg" aria-hidden="true">
      <div className="glow-circle glow-circle-one" />
      <div className="glow-circle glow-circle-two" />
    </div>
      <AppInner />
    </AuthProvider>
  );
}